import React from 'react';

function Privacy() {
  return (
    <div className="container py-4">
      <h1 className="display-4 mb-4 text-center">Privacy Policy</h1>
      
      <div className="row">
        <div className="col-12 col-lg-8 mx-auto" style={{ textAlign: 'left' }}>
          <h2 className="mt-4 mb-3">Our Commitment to Privacy</h2>
          <p className="lead" style={{ textAlign: 'left' }}>
            At BioEra, we take your privacy seriously. This Privacy Policy explains how we collect, use, and protect your information when you use our website and game.
          </p>

          <h3 className="mt-4 mb-3">Information We Collect</h3>
          <p>
            We collect minimal personal information to operate our services:
          </p>
          <ul>
            <li><strong>Contact Forms:</strong> When you submit feedback or contact forms, we collect your name, email address, and message content.</li>
            <li><strong>Order Information:</strong> When you place an order, we collect your name, email, and shipping address.</li>
            <li><strong>Automatic Information:</strong> We may collect basic usage information such as browser type and pages visited to improve our website.</li>
          </ul>

          <h3 className="mt-4 mb-3">How We Use Your Information</h3>
          <p>
            We use the information we collect only for legitimate purposes:
          </p>
          <ul>
            <li>To respond to your feedback and support requests</li>
            <li>To process and fulfill your orders</li>
            <li>To improve our website and game experience</li>
            <li>To send you order confirmations and updates (only when you've opted in)</li>
          </ul>

          <h3 className="mt-4 mb-3">Children's Privacy</h3>
          <p>
            BioEra is designed for curious minds. We do not knowingly collect personal information from children under 13 without parental consent. Parents or guardians who believe their child has provided information should contact us immediately at contact@bioeragame.com.
          </p>

          <h3 className="mt-4 mb-3">Data Protection</h3>
          <p>
            We implement appropriate security measures to protect your information from unauthorized access. However, no method of transmission over the internet is 100% secure.
          </p>

          <h3 className="mt-4 mb-3">Third-Party Sharing</h3>
          <p>
            We do not sell, trade, or rent your personal information to third parties. We only share information with trusted service providers necessary to deliver our services (such as payment processors), and only under strict confidentiality agreements.
          </p>

          <h3 className="mt-4 mb-3">Your Rights</h3>
          <p>
            You have the right to:
          </p>
          <ul>
            <li>Request access to the personal information we hold about you</li>
            <li>Request correction of inaccurate information</li>
            <li>Request deletion of your information (subject to legal requirements)</li>
            <li>Opt-out of marketing communications</li>
          </ul>

          <h3 className="mt-4 mb-3">Cookies</h3>
          <p>
            Our website uses minimal cookies to maintain site functionality and remember your preferences. You can disable cookies through your browser settings if desired.
          </p>

          <h3 className="mt-4 mb-3">External Links</h3>
          <p>
            Our website may contain links to external sites. We are not responsible for the privacy practices of these third-party websites. We encourage you to review their privacy policies.
          </p>

          <h3 className="mt-4 mb-3">Changes to This Policy</h3>
          <p>
            We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date. Your continued use of our website constitutes acceptance of any changes.
          </p>

          <h3 className="mt-4 mb-3">Contact Us</h3>
          <p>
            If you have questions or concerns about this Privacy Policy or our privacy practices, please contact us at:
          </p>
          <p>
            <strong>Email:</strong> contact@bioeragame.com<br />
            <strong>Use our Contact form:</strong> Visit the <a href="/contact">Contact page</a> to send us a message.
          </p>

          <hr className="my-5" />
          <p className="text-muted small">
            <em>Last Updated: December 2025</em>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
